import { createFileRoute } from '@tanstack/react-router';
import { AuthProvider } from 'src/features/auth/contexts/AuthContext';
import VerifyEmail from 'src/features/auth/components/VerifyEmail';
import { useAuth } from 'src/features/auth/contexts/AuthContext';

export const Route = createFileRoute('/_auth/verify-email')({
  head: () => ({
    meta: [{ title: 'Verify your email | Tekst' }],
  }),
  component: VerifyEmailPage,
});

function VerifyEmailPage() {
  return (
    <AuthProvider>
      <VerifyEmailContent />
    </AuthProvider>
  );
}

function VerifyEmailContent() {
  const { logout } = useAuth();
  return <VerifyEmail redirectUrl="/" dashboardUrl="/analytics" logout={logout} className="w-[450px] h-[270px]" />;
}
